import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./HeroSlider.css";
import api, { API_URL, BACKEND_URL } from "../util/api";

const HeroSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
   const [slides, setSlides] = useState([ { 'name':"loading...." ,  'image_path' :  "slidders/loading_slider.png"  , "id" : 0} ]);


  /* let the error slider comes from the server   */

  useEffect(() => {

    api.get(API_URL + "/sliders")
      .then(res => {
        if (res.data.success === true) {
        setSlides(res.data.slides);
  
        }

      })
      .catch(err => {
        console.log(err);
      })

  }, []);


 

  return (
    <header className="hero-wrapper">
      <Swiper
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        effect="fade"
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        pagination={{ clickable: true }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        className="hero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="hero-slide">
              <div className="hero-glass" >

                <div className="hero-overlay" style={{ backgroundImage: `url(${slide.image_path})` }} ></div>
                <img
                  src={slide.image_path}
                  alt="Hero Slide"
                  className="hero-image"
                />
                <div className="hero-caption">
                  <h1>{slide.name}</h1>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}

        {/* Custom Navigation */}
        <div className="hero-nav">
          <button align="center" ref={prevRef} className="hero-prev" aria-label="Previous slide">
            ‹
          </button>
          <button align="center" ref={nextRef} className="hero-next" aria-label="Next slide">
            ›
          </button>
        </div>
      </Swiper>
    </header>
  );
};

export default HeroSlider;
